import { useCart } from '@retainerclub/hooks';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import CheckoutSuccessMessage from './CheckoutSuccessMessage';
import CheckoutSuccessSummary from './CheckoutSuccessSummary';

function CheckoutSuccess() {
  const { cartId, removeCart } = useCart();
  const { state } = useLocation();
  const clearedCartIdRef = useRef(null);
  const completedCartId = state?.completedCartId || null;

  useEffect(() => {
    if (
      !completedCartId ||
      completedCartId !== cartId ||
      clearedCartIdRef.current === completedCartId
    ) {
      return;
    }

    clearedCartIdRef.current = completedCartId;
    removeCart();
  }, [cartId, completedCartId, removeCart]);

  return (
    <div className="relative mb-24">
      <div className="fixed z-0 h-[500px] w-full overflow-hidden bg-cover bg-linear-to-t bg-top from-rcprimary-200 to-rcprimary-500" />

      <div className="relative col-span-full mx-auto flex max-w-7xl flex-col gap-y-4 sm:pt-4">
        <div className="bg-gray-50 sm:mt-8 sm:rounded-lg">
          <div className="mx-auto max-w-2xl px-4 pt-8 pb-24 sm:px-6 lg:max-w-7xl lg:px-8">
            <div className="lg:grid lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16">
              <CheckoutSuccessMessage />

              <CheckoutSuccessSummary />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CheckoutSuccess;
